/* NEX - graffiti melting titles */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = '.hero__title,.section__title,.wd__title,.wd__dtitle,.banner__copy h2,.page-head h1,.page-head__big';
  var NS = 'http://www.w3.org/2000/svg';
  var BANDS = ['#2f0f5c', '#9058c0', '#4a1b82', '#c4a0f0'];
  var holder = document.createElement('div');
  holder.setAttribute('aria-hidden', 'true');
  holder.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  holder.innerHTML = '<svg xmlns="' + NS + '" width="0" height="0"><defs></defs></svg>';
  document.body.appendChild(holder);
  var defs = holder.querySelector('defs');
  var seq = 0, items = [];

  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function rng(seed) { return function () { seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0; return seed / 4294967296; }; }

  /* logo look from the letter shape: dark edge, white edge, then concentric violet bands. thin = crisper edges so narrow letters (N, M, W) stay readable */
  function filterXML(id, fs, seed, thin) {
    var u = fs / 84, bandN = fs >= 70 ? 3 : (fs >= 44 ? 2 : 1);
    var phone = window.innerWidth < 700;
    if (phone) bandN = 1;
    var blur = thin ? Math.max(.7, 1.1 * u) : Math.max(1, 2.4 * u), ds = Math.max(2, 5 * u);
    var rw = thin ? Math.max(1, 1.4 * u) : Math.max(1.2, 2.5 * u), rd = thin ? Math.max(.8, .8 * u) : Math.max(1, 1.5 * u), step = Math.max(1.8, 5.2 * u);
    if (thin) ds = Math.max(1.5, 2.2 * u);
    var x = '<filter id="' + id + '" x="-8%" y="-12%" width="116%" height="175%" color-interpolation-filters="sRGB">' +
      '<feGaussianBlur in="SourceGraphic" stdDeviation="' + blur.toFixed(2) + '" result="g"/>' +
      '<feColorMatrix in="g" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 22 -10" result="s0"/>' +
      (phone ? '<feOffset in="s0" dx="0" dy="0" result="shape"/>' :
        '<feTurbulence id="' + id + 't" type="fractalNoise" baseFrequency="0.012 0.02" numOctaves="1" seed="' + (seed % 50) + '" result="n"/>' +
        '<feDisplacementMap in="s0" in2="n" scale="' + ds.toFixed(1) + '" xChannelSelector="R" yChannelSelector="G" result="shape"/>') +
      '<feMorphology in="shape" operator="dilate" radius="' + (rw + rd).toFixed(2) + '" result="m0"/>' +
      '<feFlood flood-color="#12042b"/><feComposite in2="m0" operator="in" result="k0"/>' +
      '<feMorphology in="shape" operator="dilate" radius="' + rw.toFixed(2) + '" result="m1"/>' +
      '<feFlood flood-color="#ffffff"/><feComposite in2="m1" operator="in" result="k1"/>' +
      '<feFlood flood-color="' + BANDS[0] + '"/><feComposite in2="shape" operator="in" result="k2"/>';
    var merge = '<feMergeNode in="k0"/><feMergeNode in="k1"/><feMergeNode in="k2"/>';
    for (var i = 1; i <= bandN; i++) {
      x += '<feMorphology in="shape" operator="erode" radius="' + (step * i).toFixed(2) + '" result="e' + i + '"/>' +
        '<feFlood flood-color="' + BANDS[i] + '"/><feComposite in2="e' + i + '" operator="in" result="b' + i + '"/>';
      merge += '<feMergeNode in="b' + i + '"/>';
    }
    return x + '<feMerge>' + merge + '</feMerge></filter>';
  }

  function applyFilter(it) {
    var fs = parseFloat(getComputedStyle(it.el).fontSize) || 60;
    if (it.fs && Math.abs(it.fs - fs) < 2) return;
    it.fs = fs;
    var old = document.getElementById(it.id);
    if (old) old.parentNode.removeChild(old);
    var t = document.createElementNS(NS, 'g');
    t.innerHTML = filterXML(it.id, fs, it.seed, it.el.hasAttribute('data-thin'));
    defs.appendChild(t.firstChild);
    it.turb = document.getElementById(it.id + 't');
    it.wrap.style.filter = 'url(#' + it.id + ') drop-shadow(0 .05em .09em rgba(10,0,30,.55))';
  }

  function build(el) {
    if (el.getAttribute('data-nx')) return null;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return null;
    el.setAttribute('data-nx', '1');
    el.setAttribute('data-melt', '1');
    el.setAttribute('aria-label', text);
    var seed = hash(text), R = rng(seed);
    var wrap = document.createElement('span');
    wrap.className = 'nx-t';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.setProperty('--tilt', (R() * 5 - 3).toFixed(1) + 'deg');
    wrap.style.letterSpacing = (0.02 + R() * 0.035 + (el.hasAttribute('data-thin') ? 0.03 : 0)).toFixed(3) + 'em';
    var n = 0;
    text.split(' ').forEach(function (word, wi) {
      if (wi) wrap.appendChild(document.createTextNode(' '));
      var w = document.createElement('span');
      w.className = 'nx-w';
      word.split('').forEach(function (ch) {
        var l = document.createElement('span');
        l.className = 'nx-l';
        l.textContent = ch;
        l.style.setProperty('--n', n);
        l.style.setProperty('--r', (R() * 7 - 3.5).toFixed(1) + 'deg');
        l.style.setProperty('--y', (R() * 0.09 - 0.045).toFixed(3) + 'em');
        l.style.setProperty('--sc', (0.95 + R() * 0.12).toFixed(3));
        if (/[A-Za-z0-9]/.test(ch) && R() < 0.42) {
          var d = document.createElement('i');
          d.className = 'nx-d';
          d.style.setProperty('--x', (22 + R() * 56).toFixed(0) + '%');
          d.style.setProperty('--len', (0.3 + R() * 0.6).toFixed(2) + 'em');
          d.style.setProperty('--dd', (4 + R() * 4).toFixed(1) + 's');
          l.appendChild(d);
        }
        w.appendChild(l);
        n++;
      });
      wrap.appendChild(w);
    });
    el.textContent = '';
    el.appendChild(wrap);
    var it = { el: el, wrap: wrap, id: 'nxf' + (++seq), seed: seed, ph: R() * 6.28, vis: false, until: 0, count: n };
    wrap.addEventListener('mouseenter', function () { hover(it); });
    items.push(it);
    applyFilter(it);
    return it;
  }

  function play(it) {
    it.wrap.classList.remove('is-in', 'is-hover', 'is-done');
    void it.wrap.offsetWidth;
    it.wrap.classList.add('is-in');
    it.until = performance.now() + 1200;
    clearTimeout(it.doneT);
    /* once the entrance has finished, drop the animations so the page goes fully idle */
    it.doneT = setTimeout(function () { it.wrap.classList.add('is-done'); }, it.count * 9 + 1000);
  }

  /* hover: one gentle stretch, then back to still (no endless animation) */
  function hover(it) {
    var now = performance.now();
    if (now - (it.lastHover || 0) < 3500 || !it.wrap.classList.contains('is-in')) return;
    it.lastHover = now;
    it.wrap.classList.remove('is-hover');
    void it.wrap.offsetWidth;
    it.wrap.classList.add('is-hover');
    it.until = now + 1800;
    wake();
    setTimeout(function () { it.wrap.classList.remove('is-hover'); }, 1800);
  }

  /* liquid wobble at ~12fps, only while a title is entering or hovered, then it freezes */
  var last = 0, running = false;
  function tick(ts) {
    var any = false;
    if (ts - last > 80) {
      last = ts;
      items.forEach(function (it) {
        if (!it.turb || !it.until || ts > it.until) return;
        any = true;
        var a = ts * 0.0009 + it.ph;
        it.turb.setAttribute('baseFrequency', (0.012 + Math.sin(a) * 0.004).toFixed(4) + ' ' + (0.02 + Math.cos(a * 0.8) * 0.005).toFixed(4));
      });
      if (!any) { running = false; return; }
    }
    requestAnimationFrame(tick);
  }
  function wake() { if (!running && !reduce) { running = true; requestAnimationFrame(tick); } }

  function init() {
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var it = e.target.__nx;
        if (!it) return;
        it.vis = e.isIntersecting;
        if (e.isIntersecting) { if (!it.shown) { it.shown = true; play(it); } wake(); }
      });
    }, { threshold: 0.2 }) : null;

    [].forEach.call(document.querySelectorAll(SEL), function (el) {
      var it = build(el);
      if (!it) return;
      el.__nx = it;
      /* titles inside the collection picker replay when their panel opens */
      var panel = el.closest('.wd__detail');
      var wd = el.closest('.wd');
      if (panel || (wd && el.classList.contains('wd__title'))) {
        var target = panel || wd, cls = panel ? 'is-in' : 'is-ready';
        new MutationObserver(function (recs) {
          var on = target.classList.contains(cls);
          var added = recs.some(function (r) { return (' ' + (r.oldValue || '') + ' ').indexOf(' ' + cls + ' ') < 0; });
          it.vis = on;
          if (on && added) { play(it); wake(); }
        }).observe(target, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
        if (target.classList.contains(cls)) { it.vis = true; play(it); wake(); }
      } else if (io) {
        io.observe(el);
      } else {
        play(it); it.vis = true;
      }
      if (reduce) { it.wrap.classList.add('is-in', 'is-done'); }
    });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { items.forEach(applyFilter); }, 200);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();